import React from "react";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import { realAPI } from "../../services/realAPI";

interface PasswordResetContainerProps {
  type: "forgot" | "reset";
}

const PasswordResetContainer: React.FC<PasswordResetContainerProps> = ({
  type,
}) => {
  const handleForgotPassword = async (email: string): Promise<void> => {
    try {
      await realAPI.forgotPassword(email);
    } catch (error: any) {
      // Re-throw the error so the component can handle it
      throw new Error(error.message || "Failed to send reset email");
    }
  };

  const handleResetPassword = async (
    token: string,
    password: string
  ): Promise<void> => {
    try {
      await realAPI.resetPassword(token, password);
    } catch (error: any) {
      // Re-throw the error so the component can handle it
      throw new Error(error.message || "Failed to reset password");
    }
  };

  const handleValidateToken = async (token: string): Promise<boolean> => {
    try {
      await realAPI.validateResetToken(token);
      return true;
    } catch (error: any) {
      // If the API throws an error, the token is invalid
      throw new Error(error.message || "Invalid or expired token");
    }
  };

  if (type === "forgot") {
    return <ForgotPassword onSubmit={handleForgotPassword} />;
  }

  if (type === "reset") {
    return (
      <ResetPassword
        onReset={handleResetPassword}
        onValidateToken={handleValidateToken}
      />
    );
  }

  return null;
};

export default PasswordResetContainer;
